import { render, staticRenderFns } from "./music-duration-adjuster.vue?vue&type=template&id=dbfd53b4&scoped=true&"
import script from "./music-duration-adjuster.vue?vue&type=script&lang=js&"
export * from "./music-duration-adjuster.vue?vue&type=script&lang=js&"
import style0 from "./music-duration-adjuster.vue?vue&type=style&index=0&id=dbfd53b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfd53b4",
  null
  
)

export default component.exports